import {PolyNodeDataRegister} from './../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDataRegister';
import {PolyNodeDataRegisterDummy} from './../../polygonjs-editor/src/editor/npm_module/NpmModuleTypes';
import {
	BasePolyNodeSaveController,
	PolyNodeCRUDServerResponse,
} from '../../polygonjs-editor/src/editor/core/_BasePolyNodeSaveController';
import {Csrf} from '../../polygonjs-editor/src/editor/core/Csrf';
import {StoreController} from '../../polygonjs-editor/src/editor/store/controllers/StoreController';
import {NodeContext} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {BaseNodeType} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/_Base';
import {PolyNodeController} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeController';

export class WebEditorPolyNodeSaveController extends BasePolyNodeSaveController {
	readAndRegisterPolyNodes() {
		const poly_node_elements = document.querySelectorAll('[data-poly-node]');
		for (let i = 0; i < poly_node_elements.length; i++) {
			const element = poly_node_elements[i] as HTMLElement;
			const nodeType = element.dataset['nodeType'];
			const nodeContext = element.dataset['nodeContext'];
			const dataStr = element.dataset['nodeData'];
			if (nodeType && nodeContext && dataStr) {
				try {
					const data = JSON.parse(dataStr);
					PolyNodeController.createNodeClassAndRegister({
						node_type: nodeType,
						node_context: nodeContext as NodeContext,
						data,
					});
				} catch (e) {
					console.warn(`could not load poly node ${nodeContext}/${nodeType}`);
				}
			} else {
				console.log(`found invalid polynode element`, element, {nodeType, nodeContext, dataStr});
			}
		}
	}

	async create(node: BaseNodeType, polyNodeData: PolyNodeDataRegisterDummy): Promise<BaseNodeType | undefined> {
		const {node_context, node_type, data} = polyNodeData;
		const username = StoreController.editor.currentUser.username();

		const url = `/api/poly_nodes/${username}/${node_context}/${node_type}`;
		const response = await fetch(url, {
			body: JSON.stringify(data),
			method: 'POST',
			headers: Csrf.headers(),
		});
		const json = (await response.json()) as PolyNodeCRUDServerResponse;
		if (json.error) {
			StoreController.editor.status.setError(json.error);
		} else {
			const node_context = polyNodeData.node_context as NodeContext;
			const convertedPolyNodeData: PolyNodeDataRegister<NodeContext> = {
				node_context,
				node_type: polyNodeData.node_type,
				data: polyNodeData.data,
			};
			const newNode = this._createPolyNodeAndReplaceNode(node, convertedPolyNodeData);
			StoreController.editor.status.setMessage('poly node created');
			if (newNode) {
				return newNode;
			}
		}
	}

	async update(node: BaseNodeType, polyNodeData: PolyNodeDataRegisterDummy): Promise<BaseNodeType | undefined> {
		const {node_context, node_type, data} = polyNodeData;
		const username = StoreController.editor.currentUser.username();

		const url = `/api/poly_nodes/${username}/${node_context}/${node_type}`;
		const response = await fetch(url, {
			body: JSON.stringify(data),
			method: 'PATCH',
			headers: Csrf.headers(),
		});
		const json = (await response.json()) as PolyNodeCRUDServerResponse;
		if (json.error) {
			StoreController.editor.status.setError(json.error);
		} else {
			const node_context = polyNodeData.node_context as NodeContext;
			const convertedPolyNodeData: PolyNodeDataRegister<NodeContext> = {
				node_context,
				node_type: polyNodeData.node_type,
				data: polyNodeData.data,
			};
			const newNode = this._updatePolyNodeAndReplaceNodes(node, convertedPolyNodeData);
			StoreController.editor.status.setMessage('poly node updated');
			if (newNode) {
				return newNode;
			}
		}
	}
}
